import type {
    ActivationAlertsContractEngagementScoreWithChange,
    ActivationAlertsContractSocialMediaEngagementResponse,
} from "@similarweb/pro-api-client";

import type { DomainInfo } from "../../../common/widget/table/useDomainColumn";

type WithLeader<T> = T & { isLeader: boolean };

type MetricWithLeader = WithLeader<{ value: number }>;

export const METRIC_KEYS = ["views", "comments", "reactions", "shares"] as const;

export type MetricKey = (typeof METRIC_KEYS)[number];

export type SocialMediaEngagementRow = {
    [K in MetricKey]: MetricWithLeader;
} & {
    domain: DomainInfo;
    engagementScore: WithLeader<ActivationAlertsContractEngagementScoreWithChange>;
};

/** The raw API item type for a single engagement row. */
export type SocialMediaEngagementApiItem = ActivationAlertsContractSocialMediaEngagementResponse;
